import React from 'react';

interface BulkListPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  onPageChange: (page: number) => void;
  t: (key: string) => string;
}

export const BulkListPagination: React.FC<BulkListPaginationProps> = ({
  page,
  totalPages,
  total,
  onPageChange,
  t,
}) => {
  if (totalPages <= 1 && total === 0) {
    return null;
  }

  return (
    <div className="mt-4 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div className="text-sm text-gray-600">
        {t('totalRecords')}: {total}
        {totalPages > 1 && (
          <span className="ml-2">
            ({t('page')} {page} {t('of')} {totalPages})
          </span>
        )}
      </div>
      {totalPages > 1 && (
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onPageChange(1)}
            disabled={page <= 1}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm"
          >
            {t('first')}
          </button>
          <button
            type="button"
            onClick={() => onPageChange(Math.max(1, page - 1))}
            disabled={page <= 1}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm"
          >
            {t('previous')}
          </button>
          <span className="text-sm text-gray-600 px-2">
            {page} / {totalPages}
          </span>
          <button
            type="button"
            onClick={() => onPageChange(Math.min(totalPages, page + 1))}
            disabled={page >= totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm"
          >
            {t('next')}
          </button>
          <button
            type="button"
            onClick={() => onPageChange(totalPages)}
            disabled={page >= totalPages}
            className="px-3 py-1 border rounded disabled:opacity-50 text-sm"
          >
            {t('last')}
          </button>
        </div>
      )}
    </div>
  );
};
